/* unplugin-vue-components disabled */import __unplugin_components_2 from '/var/repos/bic-vue/src/components/login/SignInForm.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/Configurator.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/navbar/ConfiguratorNavbar.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page--configurator relative h-full flex flex-col"
};
const _hoisted_2 = {
  key: 1,
  class: "py-8 px-8"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center p-16"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "text-xl"
}, "This box does not exist."), /*#__PURE__*/_createElementVNode("p", {
  class: "text-xl"
}, [/*#__PURE__*/_createTextVNode("Please visit "), /*#__PURE__*/_createElementVNode("a", {
  class: "underline",
  href: "/star-here"
}, "Start Here page"), /*#__PURE__*/_createTextVNode(".")])], -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 2,
  class: "py-8 px-8"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center p-16"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "text-xl"
}, "Configuration does not exist."), /*#__PURE__*/_createElementVNode("p", {
  class: "text-xl"
}, [/*#__PURE__*/_createTextVNode("Please visit your "), /*#__PURE__*/_createElementVNode("a", {
  class: "underline",
  href: "/my-account"
}, "Account page"), /*#__PURE__*/_createTextVNode(".")])], -1);
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 3,
  class: "flex flex-col justify-center items-center p-8"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", {
  class: "text-xl"
}, "Please login to access your configuration", -1);
const _hoisted_10 = {
  class: "p-8"
};
import { queryToObject } from "@/utils/common";
import { useConfigurationStore } from '@/stores/configurationModule';
import { useMainStore } from '@/stores/store';
import { useAppStateStore } from '@/stores/appState';
import { useAuthStore } from '@/stores/auth';
import useBoxQueryParameters from '@/composables/useBoxQueryParameters';
export default {
  __name: 'ConfiguratorPage',
  setup(__props) {
    const configurationStore = useConfigurationStore();
    const {
      clearConfiguration
    } = configurationStore;
    const mainStore = useMainStore();
    const {
      appMode
    } = storeToRefs(mainStore);
    const appState = useAppStateStore();
    const {
      setUseBoxQueryParametersError
    } = appState;
    const {
      hasConfigurationId,
      showConfigurator,
      useBoxQueryParametersError,
      componentToLoad,
      fetchingBoxData
    } = storeToRefs(appState);
    const authStore = useAuthStore();
    const {
      isUser
    } = storeToRefs(authStore);
    async function init() {
      try {
        fetchingBoxData.value = true;
        const query = queryToObject(window.location.search);
        setUseBoxQueryParametersError(false);
        await useBoxQueryParameters(query);
      } catch (error) {
        console.error(error);
        setUseBoxQueryParametersError(true);
      } finally {
        fetchingBoxData.value = false;
        // Set component to load
      }
    }
    onMounted(async () => {
      await init();
    });
    onBeforeUnmount(() => {
      clearConfiguration();
    });

    // Necessary because the selected object/s is in the store, so on entering the configurator
    // the second time there is an active object if one stayed active after first leaving
    // onBeforeRouteLeave(() => {
    // });

    // Test
    // =======================================
    const theCanvas = ref(null);
    const updateTheCanvas = canvas => {
      theCanvas.value = canvas;
    };
    provide('theCanvas', {
      theCanvas,
      updateTheCanvas
    });
    // =======================================

    // @TODO: Temp
    const sampleConfigurations = [{
      url: '?slug=mbtl-10-8-4-ww&insidePrinting=true',
      label: 'Mailer',
      path: '/',
      query: {
        "type": "mbtl",
        "length": 10,
        "width": 8,
        "depth": 4,
        "quantity": 25,
        "insidePrinting": true,
        "varId": 12 // @NOTE - EXAMPLE VAR ID
      }
    }, {
      url: '?slug=mbti-10-8-3-wk&quantity=25&insidePrinting=false',
      label: 'Literature',
      path: '/',
      query: {
        "type": "mbti",
        "length": 10,
        "width": 8,
        "depth": 3,
        "quantity": 25,
        "insidePrinting": false,
        "varId": 44 // @NOTE - EXAMPLE VAR ID
      }
    }, {
      url: '?slug=sb-12-12-6&quantity=25&insidePrinting=false',
      label: 'Shipping',
      path: '/',
      query: {
        "type": "sb",
        "length": 12,
        "width": 12,
        "depth": 6,
        "quantity": 25,
        "insidePrinting": false,
        "varId": 72 // @NOTE - EXAMPLE VAR ID
      }
    }];
    function onClickSampleBoxNavigate(sampleLink) {
      // create: use router to navigate to sampleLink.path with query parameters
      const searchParams = new URLSearchParams(sampleLink.url);
      window.location.search = searchParams.toString();
    }
    async function onLoggedIn() {
      await init();
    }
    return (_ctx, _cache) => {
      const _component_ConfiguratorNavbar = __unplugin_components_0;
      const _component_Configurator = __unplugin_components_1;
      const _component_SignInForm = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ConfiguratorNavbar, {
        ref: "navbar"
      }, null, 512), _unref(componentToLoad) === 'configurator' ? (_openBlock(), _createBlock(_component_Configurator, {
        key: 0
      })) : _unref(componentToLoad) === 'start-here' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _unref(componentToLoad) === 'my-account' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _unref(componentToLoad) === 'login' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_SignInForm, {
        whichForm: "login",
        shouldRefresh: true,
        onUserLoggedIn: onLoggedIn
      })])])) : _createCommentVNode("", true)]);
    };
  }
};